import { Button, Spinner } from "@bphxd/ds-core-react";
import React, { useState } from "react";
import ACSearch from "./ACSearch";
import ACUploadModal from "./ACUploadModal";
import ACTable from "./ACTable";
import { getAnnualCertificateData, uploadAnnualCertificate } from "../../api/ACertificate/annualCertificate";
import axios from "axios";
import { annualCertificateSearch } from "../../api/endpoints";
import { useMsal } from "@azure/msal-react";
import PaginationControls from "../TaxCertificate/PaginationControls";

export default function ACHome() {
    const [noData, setNoData] = useState<string>("");
    const [searchResults, setSearchResults] = useState<any[]>([]);
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageSize] = useState(10);
    const [hasMore, setHasMore] = useState(false);
    const [searchField, setSearchField] = useState<string>("");
    const [searchValue, setSearchValue] = useState<string>("");

    const token = sessionStorage.getItem("jwt");
    const role = sessionStorage.getItem("role");
    const { instance, accounts } = useMsal();
    const accessTokenRequest = {
        account: accounts[0],
        scopes: ["User.Read"],
    };

    const userEmail = accessTokenRequest.account.username;

    const handleACSearch = async (searchField: string, searchVal: string) => {
        console.log("Search initiated with field:", searchField, "and value:", searchVal);
        try {
            setNoData("");
            setSearchResults([]);
            setCurrentPage(1);
            setSearchField(searchField);
            setSearchValue(searchVal);
            setIsLoading(true);

            const params = {
                customerAccountNumber: searchField === "sold_to_id" ? searchVal.trim() : "",
                customerAccountName: searchField === "sold_to_name" ? searchVal.trim() : "",
                offSet: "0",
            };

            const results = (await getAnnualCertificateData(params, token)) || {};
            console.log("Search results:", results);

            if (results.data && results.data.length > 0) {
                const data = mapExpiredinStatus(results.data);
                setSearchResults(data);
                setTotalRecords(results.pagination?.total || data.length);
                setHasMore(results.pagination?.hasMore || false);
            } else {
                const fieldLabel = searchField === "sold_to_id" ? "Sold To ID" : "Sold To Name";
                setNoData(`There are no documents available for this ${fieldLabel}. Please upload a document or wait for them to be available.`);
                setSearchResults([]);
                setTotalRecords(0);
                setHasMore(false);
            }
        } catch (error) {
            console.error("Search error:", error);
            setNoData("An error occurred while searching. Please try again.");
            setSearchResults([]);
            setTotalRecords(0);
            setHasMore(false);
        } finally {
            setIsLoading(false);
        }
    };

    const mapExpiredinStatus = (data: any) => {
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);

        data.forEach((item: any) => {
            console.log("Checking item:", item.expiryDate);
            if (item.expiryDate) {
                const expiryDate = new Date(item.expiryDate);
                expiryDate.setHours(0, 0, 0, 0);

                if (expiryDate < currentDate) {
                    item.status = "Expired";
                }
            }
        });

        return data;
    };

    const handlePageChange = async (newPage: number) => {
        setCurrentPage(newPage);
        setIsLoading(true);
        try {
            const offset = (newPage - 1) * pageSize;
            const params = {
                customerAccountNumber: searchField === "sold_to_id" ? searchValue.trim() : "",
                customerAccountName: searchField === "sold_to_name" ? searchValue.trim() : "",
                offSet: offset.toString(),
            };

            const results = (await getAnnualCertificateData(params, token)) || {};

            if (results.data && results.data.length > 0) {
                const data = mapExpiredinStatus(results.data);
                setSearchResults(data);
                setTotalRecords(results.pagination?.total || data.length);
                setHasMore(results.pagination?.hasMore || false);
                // Scroll to top of table
                window.scrollTo({ top: 0, behavior: "smooth" });
            }
        } catch (error) {
            console.error("Pagination error:", error);
            setNoData("An error occurred while loading more records. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleUpload = () => {
        setShowUploadModal(true);
    };

    const handleCloseModal = () => {
        setShowUploadModal(false);
    };

    const handleSubmitUpload = async (formData: any) => {
        setIsLoading(true);
        const payload = {
            ...formData,
            uploaded_by: userEmail,
            created_by: userEmail,
            updated_by: userEmail,
            Approved_by: userEmail,
        };
        console.log("Form submitted:", payload);
        try {
            const res = await uploadAnnualCertificate(payload, token);
            setShowUploadModal(false);
            setShowSuccessModal(true);
            setIsLoading(false);
        } catch (error) {
            console.error("Upload error:", error);
            setIsLoading(false);
        }
    };

    const handleCloseSuccessModal = () => {
        setShowSuccessModal(false);
    };

    return (
        <div className="container-fluid mt-4">
            {/* Search Section with Upload Button */}
            <div className="row mb-4 p-3">
                <div className="col-12">
                    <div className="d-flex align-items-center justify-content-between gap-2" style={{ width: "100%" }}>
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <ACSearch
                                onACSearch={handleACSearch}
                                setNoData={setNoData}
                                onhandleUpload={handleUpload}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Search Results Section */}
            {isLoading && !showUploadModal ? (
                <div className="table-loader">
                    <Spinner color="brand" />
                </div>
            ) : (
                <div>
                    {searchResults.length > 0 ? (
                        <div className="row mb-4">
                            <div className="col-12">
                                <ACTable rowData={searchResults} />
                            </div>
                            <div className="col-12 mt-3">
                                <PaginationControls
                                    currentPage={currentPage}
                                    totalRecords={totalRecords}
                                    pageSize={pageSize}
                                    onPageChange={handlePageChange}
                                />
                            </div>
                        </div>
                    ) : (
                        <div>
                            {noData !== "" && (
                                <div
                                    style={{ height: "300px", width: "100%", textAlign: "center" }}
                                    className="no-Data-div"
                                >
                                    {noData}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            )}

            {/* Upload Modal */}
            <ACUploadModal
                show={showUploadModal}
                onClose={handleCloseModal}
                onSubmit={handleSubmitUpload}
                isLoading={isLoading}
            />

            {/* Success Modal */}
            {showSuccessModal && (
                <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Success</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={handleCloseSuccessModal}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <p>Annual Certificate uploaded successfully!</p>
                            </div>
                            <div className="modal-footer">
                                <Button onClick={handleCloseSuccessModal}>Close</Button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}